import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Location } from '@angular/common';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { NgxSpinnerService } from 'ngx-spinner';
import { saveAs } from 'file-saver';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { Rubro } from '@shared/models/despacho/Rubro';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from '@shell/message.service';
import { VisorImpuestoComponent } from '../visor-impuesto/visor-impuesto.component';
import { ImpuestoPercepcion } from '@shared/models/facturacion/ImpuestoPercepcion';
import { UsuarioService } from '@account/usuario.service';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { TipoDocumento } from '@shared/enums/tipoDocumento';
import { NotificacionesService } from '@abm/notificacion/notificaciones.service';
import { NotificacionesComprobantes } from '@shared/models/notificaciones/NotificacionesComprobantes';
import { ErrorModel } from '@shared/models/ErrorModel';
import { EstadoFactura } from '@shared/enums/EstadoFactura';
import { TipoMoneda } from '@shared/enums/tipoMoneda';
import { CondicionVenta } from '@shared/enums/condicionVenta';
import { TipoMovimiento } from '@shared/models/facturacion/TipoMovimiento';
import { Renglon } from '@shared/models/facturacion/Renglon';
import { VisorCuponComponent } from '../visor-cupon/visor-cupon.component';
import { CodigoImpuesto } from '@shared/enums/codigoImpuesto';
import { environment } from '@environments';
import { TipoPago } from '@shared/enums/tipoPago';
import { FacturaService } from '@shared/factura.service';
import { PaymentStatus } from "@shared/enums/PaymentStatus";

@Component({
  selector: 'app-visor-comprobante',
  templateUrl: './visor-comprobante.component.html',
  styleUrls: ['./visor-comprobante.component.css']
})
export class VisorComprobanteComponent implements OnInit, OnChanges {

  cuit: string;
  columnas = [];
  mensajeSpinner: string;
  esDolar: boolean = false;
  rubros: Rubro[] = [];
  array: any[] = [];
  string: string = '';
  efectivo: number;

  @Input() facturaObtenida: Comprobante;
  @Input() mostrarPanelBotones?: boolean = false;

  impresionTermica: boolean = true;
  mostrarMensajeFacturacionEnPruebas: boolean = false;
  descargando: boolean = false;
  reenviando: boolean = false;
  mensajeError: string;

  aeroplanta: Aeroplanta[] = [];
  EstadoFactura=EstadoFactura;
  TipoDocumento=TipoDocumento;
  CondicionVenta=CondicionVenta;
  TipoMovimiento=TipoMovimiento;
  TipoMoneda=TipoMoneda;
  visualizarCupones=false;

  entornoProduccion: boolean = (environment.name == "production");

  constructor(
    private comprobanteService: ComprobanteService,
    private notificacionesService: NotificacionesService,
    private messageService: MessageService,
    private location: Location,
    public activeModal: NgbModal,
    private spinner: NgxSpinnerService,
    private usuarioService: UsuarioService,
    private facturaService: FacturaService) { }

  ngOnInit() {
    this.mostrarMensajeFacturacionEnPruebas = this.usuarioService.getAeroplantaActual().habilitarFacturacion && (!this.usuarioService.getAeroplantaActual().soloPAD);

    setTimeout(() => {/* No hacer nada */
    }, 3000);
    this.spinner.show('spinnerLista');
    switch (this.facturaObtenida.tipoMovimiento) {
      case (2):
      case (7): {
        this.columnas = [
          { field: 'Rubro', header: 'Rubro' },
          { field: 'Detalle', header: 'Descripción' },
          { field: 'Cantidad', header: 'Cant.' },
          { field: 'UMedida', header: 'UM' },
          { field: 'PUnitario', header: 'Valor Unitario' },
          { field: 'Total', header: 'Total' },
        ];
        this.getRubros();
        break;
      }
      default: {
        this.columnas = [
          { field: 'Codigo', header: 'Cod.' },
          { field: 'Detalle', header: 'Descripción' },
          { field: 'Cantidad', header: 'Cant.' },
          { field: 'UMedida', header: 'UM' },
          { field: 'PUnitario', header: 'Valor Unitario' },
          { field: 'Total', header: 'Total' },
        ];
      }
    }
    this.mensajeSpinner = "Descargando..."
    this.renglones();
    this.getTotalEfectivo();
    setTimeout(() => {
      this.spinner.hide('spinnerLista');
    }, 5000);
  }

  renglones() {
    this.string = '';
    for (let i = 0; this.facturaObtenida.factura.leyendas.length > i; i++) {
      if (this.facturaObtenida.factura.leyendas[i].frame == 0 && this.facturaObtenida.factura.leyendas[i].activo) {
        this.string = `${this.string}` + `${this.facturaObtenida.factura.leyendas[i].descripcion}` + '\n';
      }
    }
    this.string = this.string.slice(0, 884);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.facturaObtenida.firstChange) {
      this.ngOnInit();
    }

    this.efectivo = 0;
    this.getTotalEfectivo();
  }

  getTotalEfectivo() {
    const factura = this.facturaObtenida.factura;

    const totalFactura = factura.total;
    const totalPago = this.facturaService.calcularTotalCupones(factura?.pago[0]?.cupones);
    const totalPagoElectronicos = this.facturaService.calcularTotalPagosElectronicos(factura.pagosElectronicos);
    // const totalDescuentoPagoElectronico = this.facturaService.calcularTotalDescuentosPagosElectronicos(factura.pagosElectronicos);

    this.efectivo = totalFactura - totalPago - totalPagoElectronicos;
  }

  getRubros() {
    this.comprobanteService.getRubros()
      .subscribe(result => {
        (this.rubros = result);
        for (let i = 0; this.rubros.length > i; i++) {
          for (let j = 0; this.facturaObtenida.factura.renglones.length > j; j++) {
            if (this.rubros[i].id == this.facturaObtenida.renglones[j].rubro.id) {
              this.facturaObtenida.renglones[j].rubro.nombre = this.rubros[i].nombre;
            }
          }
        }
      });
  }

  formatearNroDocumento(tipoDoc: number, nroDoc: string) {
    if (tipoDoc == TipoDocumento.CUIL || tipoDoc == TipoDocumento.CUIT) {
      if (nroDoc.includes("-")) {
        return (nroDoc)
      } else {
        nroDoc = nroDoc.substr(0, 2) + - + nroDoc.substr(2, 8) + - + nroDoc.substr(10);
        return (nroDoc)
      }
    } else {
      return nroDoc;
    }
  }

  leyendaTipoDocumento(tipoDoc: number) {
    if (tipoDoc == TipoDocumento.CUIT) {
      return "CUIT";
    } else if (tipoDoc == TipoDocumento.CUIL) {
      return "CUIL";
    } else if (tipoDoc == TipoDocumento.DNI) {
      return "DNI";
    } else if (tipoDoc == TipoDocumento.Extranjero) {
      return "DOCUMENTO";
    }
  }

  goBack() {
    this.location.back(); // <-- go back to previous location on cancel
  }

  onClickExport(f:Comprobante) {
    this.spinner.show('spinnerExportar');
    this.comprobanteService.exportarRemitosDeFactura(f.prefijo, f.numeroComprobante, f.tipoMovimiento)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        saveAs(blob, "factura" + f.prefijo + "-" + f.numeroComprobante + ".xlsx");
        this.spinner.hide('spinnerExportar');
      }, () => {
        this.spinner.hide('spinnerExportar');
      });
  }

  clienteDiscriminaImpuestos() {
    if (this.facturaObtenida.cliente.condicionIvaDiscrimina) {
      return true;
    } else {
      return false;
    }
  }

  clienteConsumidorFinal() {
    // como las leyendaSimple no son retroactivas, se generan a partir de la generacion de la factura
    // el backend actualiza del 2025 en adelante, las demás se descartan del circuito
    const fechaLimite = this.entornoProduccion ? new Date(2025, 1, 3) : new Date(2025, 0, 28);
    const fechaEmision = this.facturaObtenida?.fechaEmision ? new Date(this.facturaObtenida.fechaEmision) : null;

    return fechaEmision !== null &&
          fechaEmision >= fechaLimite &&
          (this.facturaObtenida?.tipoMovimiento === TipoMovimiento.FAB || this.facturaObtenida?.tipoMovimiento === TipoMovimiento.NCB || this.facturaObtenida?.tipoMovimiento === TipoMovimiento.NDB);
  }

  clienteExento() {
    if (this.facturaObtenida != null && this.facturaObtenida.cliente.condicionIvaCodigoAfip == '02') {
      return true
    } else {
      return false
    }
  }

  obtenerPorcentaje(leyenda: string): number {
    for (const reng of this.facturaObtenida.factura.renglones) {
      for (const imp of reng.impuestosPercepciones) {
        if (imp.leyenda == leyenda) {
          return imp.valor;
        }
      }
    }
  }

  onClickView() {
    const renglones: Renglon[] = [];
    const impuestos: ImpuestoPercepcion[] = [];

    this.facturaObtenida.factura.renglones.forEach((value, index) => {
      renglones.push(this.facturaObtenida.factura.renglones[index]);
      this.facturaObtenida.factura.renglones[index].impuestosPercepciones.forEach((value2, index2) => {
        impuestos.push(this.facturaObtenida.factura.renglones[index].impuestosPercepciones[index2]);
      });
    });
    const modalRef = this.activeModal.open(VisorImpuestoComponent, { size: 'lg', centered: true, backdrop: 'static' })
    modalRef.componentInstance.renglones = renglones;
  }

  onClickViewCupon() {
    const modalRef = this.activeModal.open(VisorCuponComponent, { size: 'lg', centered: true, backdrop: 'static' })
    modalRef.componentInstance.cupones = this.facturaObtenida.factura.pago[0].cupones;
  }

  incluirPorcentajeImpuesto(codigo: CodigoImpuesto): boolean {
    if(codigo === CodigoImpuesto.IDC || codigo === CodigoImpuesto.ITC){
      return false;
    } else {
      return true;
    }
  }

  obtenerImpuestosSobreCombustiblesLiquidos(impuestos: ImpuestoPercepcion[]): ImpuestoPercepcion[] {
    return impuestos.filter((impuesto) => !this.incluirPorcentajeImpuesto(impuesto.codigo));
  }

  obtenerImpuestosValorAgregado(impuestos: ImpuestoPercepcion[]): ImpuestoPercepcion[] {
    return impuestos.filter((impuesto) => impuesto.leyenda.includes('IVA'));
  }

  onClickDownload(f: Comprobante) {
    this.descargando = true;
    this.comprobanteService.descargarFactura(f)
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        saveAs(blob, f.prefijo + '-' + f.numeroComprobante + ' ' + f.fechaHoraCreacion + '.pdf');
        this.descargando = false;
      }, () => {
        this.descargando = false;
      });
  }

  reenviarCorreo() {
    let email: any;
    this.mensajeError = null;
    this.reenviando = true;
    const comprobanteNotificaciones = new NotificacionesComprobantes();
    comprobanteNotificaciones.facturaId = this.facturaObtenida.id;
    comprobanteNotificaciones.numeroDocumento = this.facturaObtenida.cliente.numeroDocumento;
    comprobanteNotificaciones.codigoAeroplanta = this.facturaObtenida.codigoAeroplanta;
    comprobanteNotificaciones.tipoMovimiento = this.facturaObtenida.tipoMovimiento;
    comprobanteNotificaciones.prefijo = this.facturaObtenida.prefijo;
    comprobanteNotificaciones.numero = this.facturaObtenida.numeroComprobante;
    this.notificacionesService.enviarFactura(comprobanteNotificaciones)
      .subscribe((result) => {
        email = result;
        this.messageService.showSuccessLongMessage('El comprobante se reenvío a los correos: ' + email.item1);
        this.reenviando = false;
      }, (err: ErrorModel) => {
        this.messageService.showErrorLongMessage(err.description);
        this.reenviando = false;
      });
  }

  obtenerDescripcionMoneda(tipoMoneda: TipoMoneda): string {
    return tipoMoneda == TipoMoneda.PES ? 'PESOS' : 'DOLARES';
  }

  getTipoPago(tipo: number) {
    return TipoPago[tipo].toUpperCase();
  }

  getNumeroOperacion(paymentId: string) {
    try {
      const numberString = paymentId?.split('.');
      return '#'.concat(numberString[0]);
    } catch (error) {
      return '';
    }
  }

  pagosElectronicosEnApproved() {
    return this.facturaObtenida?.factura?.pagosElectronicos?.filter(
      pago => pago.estado === PaymentStatus.approved) || [];
  }

  get showCupones() {
    return this.facturaObtenida.factura?.pago[0]?.cupones?.filter(c => c.pathCuponFisico != '').length > 0;
  }

  get paymentInDiscount(): boolean {
    return this.facturaService.calcularTotalDescuentosPagosElectronicos(this.facturaObtenida.factura.pagosElectronicos) > 0;
  }

  get cashPayment(): boolean {
    return this.efectivo > 0;
  }
}


